var _circle, _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.67,
    height: 159.67,
    viewBox: "0 0 159.67 159.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.83,
    cy: 79.83,
    r: 69.7,
    fill: "#34abd8",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.81,
    y: 46.98,
    width: 50.04,
    height: 65.7,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 65.87,
    y1: 67.24,
    x2: 94.13,
    y2: 67.24,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 65.87,
    y1: 79.83,
    x2: 94.13,
    y2: 79.83,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 65.87,
    y1: 92.43,
    x2: 94.13,
    y2: 92.43,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.9e944ec3f3cac65b26669eab67cb178a.svg";
export { ForwardRef as ReactComponent };